<template>
<div> 
    <h3 class="mb-4">{{$t("message.your_shoping_cart")}}</h3>
    <div class="card" v-if="getShopcard.length>0">
      <div class="card-body">
          <h5 class="card-title">Your registers have {{getAllShopcard.length}} items not yet paid.</h5>
          <div class="table-responsive">
            <table class="table table-bordered">
                <thead class="table-dark">
                    <tr>
                        <th class="text-center align-middle" style="width:40px;">#</th>
                        <th class="align-middle">{{$t("message.item")}}</th>
                        <th class="text-center align-middle">{{$t("message.register_type")}}</th>
                        <th class="text-center align-middle" style="width:120px;">{{$t("message.price")}}</th>
                        <th class="text-center align-middle" style="width:90px;">{{$t("message.qty")}}</th>
                        <th class="text-center align-middle" style="width:120px;">{{$t("message.action")}}</th>
                    </tr>
                </thead>
                <tbody >
                    <tr v-for="(itemcard, index) in getShopcard" :key="index">
                        <td class="align-middle text-center">{{index+1}}</td>
                        <td class="align-middle">
                            <p class="nopadding fw-bold">{{$t("message.name")}}: {{itemcard.participant.lastname + ' ' + itemcard.participant.firstname}}</p>
                            <p class="nopadding fw-bold">{{$t("message.gender")}}: {{itemcard.participant.gender==1 ? $t("message.male") : $t("message.female")}}</p>
                            <p class="nopadding"><b>{{$t("message.training")}}</b>: {{itemcard.type_business_name}}</p>
                        </td>
                        <td class="align-middle text-center">{{itemcard.apply_for==1? "NEW" : "CPE"}}</td>
                        <td class="align-middle text-center">{{getAmount}} KHR</td>
                        <td class="align-middle text-center">1</td>
                        <td class="align-middle text-center">
                            <button class="btn btn-danger" @click="removeItem(itemcard)"><i class="fas fa-trash"></i></button>
                            <router-link class="btn btn-primary" :to="{name:'ShowRegister', params:{id:itemcard.id}}">
                                <i class="fas fa-edit"></i>
                            </router-link>
                            <!-- <button class="btn btn-primary"><i class="fas fa-edit"></i></button> -->
                        </td>
                    </tr>
                    <tr>
                        <td colspan="3" class="align-middle text-center fw-bold">{{$t("message.total_amount")}}:</td>
                        <td class="align-middle text-center fw-bold">{{getTotalAmount}} KHR</td>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
          </div>
      </div>
      <div class="card-footer text-end">
        <p>You have <b class="fs-5">{{getShopcard.length}}</b> items selected. Totals Amount: <b class="fs-5">{{getTotalAmount + ' KHR'}}</b> go to check out.</p>
        <router-link class="btn btn-primary" :to="{name:'continueRegister'}">{{$t("message.continue_checkout")}} <i class="fas fa-shopping-cart"></i></router-link>
        <!-- <button class="btn btn-primary">Continue Checkout <i class="fas fa-shopping-cart"></i></button> -->
      </div>
    </div>
    <div class="card" v-else>
        <div class="card-body">
            <h5 class="card-title">Your registrations have {{getAllShopcard.length}} items not yet paid.</h5>
            <h4 class="text-center pt-5">
                Please make new registration or reload page.
            </h4>
            <div class="text-center m-5">
                <router-link class="btn btn-primary" :to="{name:'register'}"><i class="fas fa-edit"></i> {{$t("message.new_registration")}}</router-link>
                <button class="btn btn-danger ms-2" @click="loadData"><i class="fas fa-sync-alt"></i> {{$t("message.reload")}}</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from "@/axios";
import { mapActions } from 'vuex';
export default {
    setup() {
        return {};
    },
    data() {
        return {
            // price: 1500000,
            price: 1200000
        };
    },
    methods: {
        showLoader() {
            return this.$loading.show({
                // Optional parameters
                container: this.$refs.formContainer,
                color: "#01B201",
                canCancel: true,
                onCancel: this.onCancelLoader
            });
        },
        ...mapActions([
            'act_shopcard',
        ]),
        async loadData(){
            this.$store.commit('changeShopcard',[]);
            let loader = this.showLoader();
            await this.act_shopcard();
            loader.hide();
        },
        removeItem(itemCard){
            let data = [...this.$store.state.shopcardStates];
            data.map(item=>{
                if(item.id == itemCard.id){
                    item.active = item.id != itemCard.id;
                }
            });
            this.$store.commit('changeShopcard',data);
        },
        async loadPrice() {
            try {
                const response = await axios.get("get-price", {
                    headers: {
                        Authorization: "Bearer " + this.$store.getters.getAuthToken
                    }
                });
                if (response.status === 200) {
                    this.price = response.data.data.amount;
                }
            } catch (error) {
                console.error("Error loading price:", error);
            }
        }
    },
    computed :{
        getAllShopcard () {
            return this.$store.getters.getAllShopcard ? this.$store.getters.getAllShopcard : []
        },
        getShopcard () {
            return this.$store.getters.getShopcard ? this.$store.getters.getShopcard : []
        },
        getAmount(){
            return Number((this.price).toFixed(1)).toLocaleString();
        },
        getTotalAmount(){
            //console.log(this.$store.getters.getShopcard);
            const totalAmount = this.$store.getters.getShopcard ? this.$store.getters.getShopcard.length * this.price : 0;
            return Number((totalAmount).toFixed(1)).toLocaleString();
        },
        getBusinessType(){
            return (t) =>{
                switch (t){
                    case '1':
                    case 1:
                        return this.$t("message.stock_business");
                    case '2':
                    case 2:
                        return this.$t("message.derivative_business");
                    case '19':
                    case 19:
                        return this.$t("message.public") + ' - ' + this.$t("message.stock_business");
                    case 20:
                    case '20':
                        return this.$t("message.public") + ' - ' + this.$t("message.derivative_business");
                    default:
                        return t;
                }
            }
        }
    },
    created() {
        this.loadPrice();
        this.loadData();
    },
    mounted() {}
}
</script>

<style scoped>
    .nopadding{
        padding: 0;
        margin: 0;
    }
</style>